export const environment = {
  production: true,
  apiRoot: 'https://kizilaykaptanapi.demo.nuevoyazilim.com',
  applicationRootUrl: 'https://kizilaykaptanyetim.demo.nuevoyazilim.com',
  apiRootDomain: 'kizilaykaptanapi.demo.nuevoyazilim.com'
};
